import React, { useEffect, useState, useMemo } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function formatCurrency(n) {
  return n.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
}

export default function PatronMusteriler() {
  const navigate = useNavigate(); // Yönlendirme için kanca
  const [cariler, setCariler] = useState([]);
  const [taksitler, setTaksitler] = useState([]);
  const [odemeler, setOdemeler] = useState([]);

  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const unsub1 = onSnapshot(collection(db, "cariler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setCariler(arr);
    });

    const unsub2 = onSnapshot(collection(db, "taksitler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setTaksitler(arr);
    });

    const unsub3 = onSnapshot(collection(db, "odemeler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setOdemeler(arr);
    });

    return () => {
      unsub1();
      unsub2();
      unsub3();
    };
  }, []);

  const alacaklilar = useMemo(() => {
    return cariler
      .map((c) => {
        const kisiTaksitleri = taksitler.filter((t) => t.cariId === c.id);
        const toplam = kisiTaksitleri.reduce((a, b) => a + b.miktar, 0);
        const odenen = kisiTaksitleri
          .filter((t) => t.durum === "Ödendi")
          .reduce((a, b) => a + b.miktar, 0);
        return {
          ...c,
          toplam,
          odenen,
          kalan: toplam - odenen,
        };
      })
      .filter((x) => x.kalan > 0);
  }, [cariler, taksitler]);

  const borclular = useMemo(() => {
    return cariler
      .map((c) => {
        const kisiGiderleri = odemeler.filter((o) => o.cariId === c.id);
        const toplam = kisiGiderleri.reduce((a, b) => a + b.miktar, 0);
        return {
          ...c,
          toplam,
        };
      })
      .filter((x) => x.toplam > 0);
  }, [cariler, odemeler]);

  // --- YENİ: TIKLAMA VE YÖNLENDİRME FONKSİYONU ---
  const handleRowClick = (cari) => {
    if (cari.cariTipi === 'Tedarikçi') {
        navigate(`/tedarikciler/${cari.id}`);
    } else {
        // Varsayılan olarak müşteri kabul edelim veya tipi 'Müşteri' ise
        navigate(`/cariler/${cari.id}`); 
    }
  };

  // --- PDF EXPORT FONKSİYONU ---
  const handlePdfExport = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("ARAS ASAF İNŞAAT - Müşteri Analiz Raporu", 14, 20);
    doc.setFontSize(10);
    doc.text(`Rapor Tarihi: ${new Date().toLocaleDateString('tr-TR')}`, 14, 26);

    doc.setFontSize(12);
    doc.setTextColor(40, 167, 69); 
    doc.text("Alacaklı Olduğumuz Müşteriler", 14, 35);
    doc.setTextColor(0, 0, 0); 

    autoTable(doc, {
      startY: 40,
      head: [['Müşteri Adı', 'Toplam Borç', 'Ödenen', 'Kalan']],
      body: alacaklilar.map(c => [
        c.adSoyad || c.firmaSahis,
        formatCurrency(c.toplam),
        formatCurrency(c.odenen),
        formatCurrency(c.kalan)
      ]),
    });

    let finalY = doc.lastAutoTable.finalY || 40;
    doc.setFontSize(12);
    doc.setTextColor(220, 53, 69); 
    doc.text("Bizim Borçlu Olduğumuz Müşteriler", 14, finalY + 15);
    doc.setTextColor(0, 0, 0);

    autoTable(doc, {
      startY: finalY + 20,
      head: [['Müşteri/Tedarikçi Adı', 'Toplam Borcunuz']],
      body: borclular.map(c => [
        c.adSoyad || c.firmaSahis,
        formatCurrency(c.toplam)
      ]),
    });

    doc.save("Musteri_Analiz_Raporu.pdf");
  };

  // --- EXCEL EXPORT FONKSİYONU ---
  const handleExcelExport = () => {
    const wb = XLSX.utils.book_new();

    const wsAlacakData = [
      ['Müşteri Adı', 'Toplam Borç', 'Ödenen', 'Kalan'],
      ...alacaklilar.map(c => [c.adSoyad || c.firmaSahis, c.toplam, c.odenen, c.kalan])
    ];
    const wsAlacak = XLSX.utils.aoa_to_sheet(wsAlacakData);
    XLSX.utils.book_append_sheet(wb, wsAlacak, "Alacaklılar");

    const wsBorcData = [
      ['Müşteri/Tedarikçi Adı', 'Toplam Borcunuz'],
      ...borclular.map(c => [c.adSoyad || c.firmaSahis, c.toplam])
    ];
    const wsBorc = XLSX.utils.aoa_to_sheet(wsBorcData);
    XLSX.utils.book_append_sheet(wb, wsBorc, "Borçlular");

    XLSX.writeFile(wb, "Musteri_Analiz_Raporu.xlsx");
  };

  return (
    <div className="admin-page">

      <div className="admin-header">
        {/* --- YENİ: Tıklanabilir Logo Alanı --- */}
        <h1 
            className="brand-logo admin-brand-header"
            onClick={() => navigate('/patron/dashboard')}
            style={{ cursor: 'pointer' }}
            title="Panele Dön"
        >
          <img src="/logo.png" width="50" alt="" />
          ARAS ASAF İNŞAAT – MÜŞTERİ ANALİZİ
        </h1>

        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div className="date-time-info" style={{marginRight: '10px'}}>
            {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
            </div>

            <button onClick={handleExcelExport} className="admin-button small" style={{backgroundColor: '#217346'}}>
                📗 Excel
            </button>
            <button onClick={handlePdfExport} className="admin-button small" style={{backgroundColor: '#b30b00'}}>
                📕 PDF
            </button>

            <Link to="/patron/dashboard" className="admin-button-secondary small">
            ← Patron Paneli
            </Link>
        </div>
      </div>

      {/* ALACAKLI OLDUĞUMUZ MÜŞTERİLER */}
      <h2 style={{ marginTop: 20, color: "#28a745" }}>Alacaklı Olduğumuz Müşteriler</h2>

      <table className="admin-table" style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th>Adı</th>
            <th>Toplam Borç</th>
            <th>Ödenen</th>
            <th>Kalan</th>
          </tr>
        </thead>

        <tbody>
          {alacaklilar.map((c) => (
            <tr 
                key={c.id} 
                className="table-row-clickable" 
                onClick={() => handleRowClick(c)}
            >
              <td>{c.adSoyad || c.firmaSahis}</td>
              <td>{formatCurrency(c.toplam)}</td>
              <td>{formatCurrency(c.odenen)}</td>
              <td>{formatCurrency(c.kalan)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* BORÇLU OLDUĞUMUZ MÜŞTERİLER */}
      <h2 style={{ marginTop: 40, color: "#dc3545" }}>Bizim Borçlu Olduğumuz Müşteriler</h2>

      <table className="admin-table" style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th>Adı</th>
            <th>Toplam Borcunuz</th>
          </tr>
        </thead>

        <tbody>
          {borclular.map((c) => (
            <tr 
                key={c.id}
                className="table-row-clickable" 
                onClick={() => handleRowClick(c)}
            >
              <td>{c.adSoyad || c.firmaSahis}</td>
              <td>{formatCurrency(c.toplam)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}